export type SidebarSide = "left" | "right";
export type SidebarWidths = Record<SidebarSide, number>;
export const DEFAULT_SIDEBAR_WIDTH = 14.5;
export function clampSidebarWidth(width: number): number {
  return Number.isFinite(width)
    ? Math.max(DEFAULT_SIDEBAR_WIDTH, Math.min(29, width))
    : DEFAULT_SIDEBAR_WIDTH;
}
export function updateSidebarWidths(
  model: SidebarWidths,
  msg: { side: SidebarSide; width: number },
): [SidebarWidths, never[]] {
  return [{ ...model, [msg.side]: clampSidebarWidth(msg.width) }, []];
}
